import React, { Component } from "react"
import { translate } from "react-translate"
import SegmentGroup, {
  Button,
  Icon,
  Select,
  Modal,
  Container,
  Input,
  Dropdown,
  Segment,
  Form,
  TextArea
} from "semantic-ui-react"
import "./ModalClients.css"
import _ from "lodash"

const optionsCivil = [
  {
    key: 1,
    text: "value_dropdown_civil_homme",
    value: "Monsieur"
  },
  { key: 2, text: "value_dropdown_civil_Madame", value: "Madame" }
]

const optionsCountry = [
  { key: 1, text: "value_dropdown_country_france", value: "France" },
  { key: 2, text: "value_dropdown_country_angleterre", value: "Angleterre" }
]

class ModalClients extends Component {
  constructor(props) {
    super(props)
    this.state = { toggle: true, modalOpen: false }
    this.eventHandler = this.eventHandler.bind(this)
  }

  handleOpen = () => this.setState({ modalOpen: true })

  handleClose = () => this.setState({ modalOpen: false })

  eventHandler(event) {
    this.setState({
      toggle: event
    })
  }

  componentWillMount() {
    let { t } = this.props
    var optionsCivilCopy = _.clone(optionsCivil)
    optionsCivilCopy = _.map(optionsCivilCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })
    var optionsCountryCopy = _.clone(optionsCountry)
    optionsCountryCopy = _.map(optionsCountryCopy, x => {
      return {
        ...x,
        text: t(x.text)
      }
    })

    this.setState({
      optionsCivil: optionsCivilCopy,
      optionsCountry: optionsCountryCopy
    })
  }

  render() {
    var callback = this.props.onSave || function() {}
    let { t } = this.props
    console.log("STATE :", this.state)

    return (
      <Modal
        id="modalClient"
        trigger={
          <Button id="bouttonEntete1" onClick={this.handleOpen}>
            {" "}
            <Icon className="add user" id="iconAddUser" name="add user" />
            {t("label_button_modal_add_client")}
          </Button>
        }
        open={this.state.modalOpen}
        onClose={this.handleClose}
      >
        <Modal.Header id="modalHeaderClient">
          {t("title_modal_new_client")}
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Container>
              <h3 className="modalMargin">{t("label_modal_type")}</h3>
              <div>
                <Button
                  className="typeBtnClientModal"
                  active={this.state.toggle}
                  attached="left"
                  onClick={() => this.eventHandler(true)}
                >
                  <Icon
                    className="user circle"
                    id="iconParticulier"
                    name="user circle"
                  />
                  {t("category_modal_particulier")}
                </Button>
                <Button
                  className="typeBtnClientModal"
                  active={!this.state.toggle}
                  attached="right"
                  onClick={() => this.eventHandler(false)}
                >
                  <Icon className="factory" id="IconFactory" name="factory" />
                  {t("category_modal_Entreprise")}
                </Button>
              </div>
              <Form>
                {this.state.toggle ? (
                  <Form.Group widths="equal">
                    <Form.Field id="nomFormClient">
                      <label className="modalMargin">{t("input_modal_name")}</label>
                      <Input
                        fluid
                        placeholder={t("placeholder_modal_name")}
                        onChange={(e, val) =>
                          this.setState({ name: val.value })
                        }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label className="modalMargin">{t("input_modal_firstname")}</label>
                      <Input
                        fluid
                        placeholder={t("placeholder_modal_firstname")}
                        onChange={(e, val) =>
                          this.setState({ firstName: val.value })
                        }
                      />
                    </Form.Field>
                    <Form.Field>
                      <label className="modalMargin">{t("input_modal_civil")}</label>
                      <Dropdown
                        selection
                        wrapSelection={false}
                        options={this.state.optionsCivil || []}
                        onChange={(e, val) =>
                          this.setState({ civil: val.value })
                        }
                        placeholder={t("placeholder_modal_civil")}
                      />
                    </Form.Field>
                  </Form.Group>
                ) : (
                  <Form.Group widths="equal">
                    <Form.Field id="corpFormClient">
                      <label>{t("category_modal_enterprise")}</label>
                      <Input
                        fluid
                        placeholder={t("placeholder_modal_enterprise")}
                        onChange={(e, val) =>
                          this.setState({ name: val.value })
                        }
                      />
                    </Form.Field>
                  </Form.Group>
                )}
              </Form>

              <Form>
                <Form.Group widths="equal">
                  <Form.Field>
                    <label className="modalMargin">
                      {t("input_modal_mail")}
                    </label>
                    <Input
                      fluid
                      placeholder={t("placeholder_modal_mail")}
                      onChange={(e, val) => this.setState({ email: val.value })}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label className="modalMargin">{t("input_modal_phone")}</label>
                    <Input
                      fluid
                      placeholder={t("placeholder_modal_phone")}
                      onChange={(e, val) => this.setState({ phone: val.value })}
                    />
                  </Form.Field>
                </Form.Group>
              </Form>
            </Container>

            <h3 className="modalMargin">{t("title_modal_adresse")}</h3>
            <Segment id="segmentForm">
              <Form>
                <Form.Field>
                  <Input
                    placeholder={t("placeholder_modal_voie")}
                    onChange={(e, val) => this.setState({ voie: val.value })}
                  />
                </Form.Field>
                <Form.Field>
                  <Input
                    placeholder={t("placeholder_modal_complement")}
                    onChange={(e, val) =>
                      this.setState({ complement: val.value })
                    }
                  />
                </Form.Field>
                <Form.Group widths="equal" style={{margin: '0'}}>
                  <Form.Field id="inputFieldPostalCode">
                    <Input
                      fluid
                      placeholder={t("placeholder_modal_postal")}
                      onChange={(e, val) =>
                        this.setState({ adress: val.value })
                      }
                    />
                  </Form.Field>
                  <Form.Field id="inputFieldCity">
                    <Input
                      fluid
                      placeholder={t("placeholder_modal_ville")}
                      onChange={(e, val) => this.setState({ ville: val.value })}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Field>
                  <Select
                    fluid
                    options={this.state.optionsCountry || []}
                    placeholder={t("placeholder_modal_dropdown_country")}
                    onChange={(e, val) => this.setState({ pays: val.value })}
                  />
                </Form.Field>
              </Form>
            </Segment>
            <h3 className="modalMargin">{t("input_modal_note")}</h3>
            <Form.Field
              id="form-textarea-control"
              control={TextArea}
              onChange={(e, val) => this.setState({ notes: val.value })}
            />
          </Modal.Description>
        </Modal.Content>
        <div class='ui divider' />
        <Modal.Actions>
          <Button id="cancelBtnClientModal">
            {t("button_modal_exit")}
          </Button>
          <Button id="submitBtnClientModal" onClick={() => callback(this.state)}>
            <Icon name="checkmark" id="checkmarkIcon" />
            {t("button_modal_save")}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default translate("ProModalClient")(ModalClients)



// WEBPACK FOOTER //
// ./src/components/Pro/Clients/ModalClients.jsx